export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Puducherry",
];

export const normalizeState = (value = "") =>
  String(value || "").toLowerCase().replace(/\s+/g, " ").trim();

export const isTamilNadu = (value = "") => {
  const normalized = normalizeState(value);
  return normalized === "tamil nadu" || normalized === "tamilnadu";
};

export const getResolvedProductType = (item = {}) => {
  const productType = String(item.productType || "").trim().toLowerCase();
  const category = String(item.category || "").trim().toLowerCase();

  if (productType === "live-fish" || category === "livestock") {
    return "live-fish";
  }

  return "accessory";
};

export const formatCategoryLabel = (value = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "General";
  return raw
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
};

export const getProductBadge = (item) =>
  getResolvedProductType(item) === "live-fish" ? "Live Fish" : "Accessories";

export const getSalesChannel = (item = {}) => {
  const value = String(item.salesChannel || "").trim().toLowerCase();
  return ["retail", "wholesale", "both"].includes(value) ? value : "retail";
};

export const isWholesaleVisible = (item = {}) => {
  const channel = getSalesChannel(item);
  return channel === "wholesale" || channel === "both";
};

export const isRetailVisible = (item = {}) => {
  const channel = getSalesChannel(item);
  return channel === "retail" || channel === "both";
};

export const getBusinessTypeLabel = (item = {}) => {
  const sellerType = String(item.sellerId?.businessType || "").trim().toLowerCase();
  if (sellerType === "wholesale") return "Wholesaler";
  if (sellerType === "hybrid") return "Wholesale + Retail";
  return "";
};

export const getWholesalePrice = (item = {}) => {
  const price = Number(item.wholesalePrice || 0);
  return price > 0 ? price : Number(item.price || 0);
};

export const getWholesaleMinQty = (item = {}) => Math.max(0, Number(item.wholesaleMinQty || 0));

export const getWholesaleCoverage = (item = {}) => {
  const regions = item.sellerId?.wholesaleRegions || [];
  if (Array.isArray(regions) && regions.length) {
    return regions.join(", ");
  }
  const cities = item.sellerId?.serviceableCities || [];
  if (Array.isArray(cities) && cities.length) {
    return cities.join(", ");
  }
  return "Chennai and nearby areas";
};

export const getDeliveryLabel = (item) =>
  getResolvedProductType(item) === "live-fish"
    ? "Live fish delivery inside Tamil Nadu only"
    : "Accessories shipping available across India";

export const getShippingPreview = (item) => {
  const rates = item.shippingRates || {};
  if (getResolvedProductType(item) === "live-fish") {
    return Number(rates.TN ?? 250);
  }
  return Number(rates.INDIA ?? rates.OTHER ?? 120);
};

export const getOfferLabels = (item = {}) => {
  const labels = item.offerSummary?.labels || [];
  if (Array.isArray(labels) && labels.length) return labels.filter(Boolean);
  return [];
};

export const getOfferHighlights = (item = {}) => {
  const promotions = item.offerSummary?.promotions || [];
  if (!Array.isArray(promotions) || !promotions.length) {
    return getOfferLabels(item).map((label) => ({
      badge: "OFFER",
      text: label,
    }));
  }

  return promotions
    .map((promo) => {
      if (!promo) return null;
      const minOrder = Number(promo.minOrderValue || 0);
      const suffix = minOrder > 0 ? ` on orders above ₹${minOrder.toFixed(0)}` : "";
      if (promo.type === "free-shipping" || promo.freeShipping) {
        return {
          badge: "FREE SHIPPING",
          text: `No shipping charge${suffix}`,
        };
      }
      if (promo.type === "free-gift") {
        return {
          badge: "FREE GIFT",
          text: `${promo.freeGiftLabel || "Gift"} added automatically${suffix}`,
        };
      }
      if (promo.discountType === "flat") {
        return {
          badge: `₹${Number(promo.discountValue || 0).toFixed(0)} OFF`,
          text: `${promo.title || "Discount"}${promo.firstOrderOnly || promo.type === "first-order" ? " for your first purchase" : ""}${suffix}`,
        };
      }
      const cap = Number(promo.maxDiscount || 0) > 0
        ? ` up to ₹${Number(promo.maxDiscount).toFixed(0)}`
        : "";
      return {
        badge: `${Number(promo.discountValue || 0).toFixed(0)}% OFF`,
        text: `${promo.title || "Discount"}${cap}${promo.firstOrderOnly || promo.type === "first-order" ? " for your first purchase" : ""}${suffix}`,
      };
    })
    .filter(Boolean);
};

export const getCartCount = () => {
  try {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    return cart.reduce((sum, item) => sum + Number(item.qty || 1), 0);
  } catch {
    return 0;
  }
};

export const readCustomer = () => {
  try {
    const raw = localStorage.getItem("customer");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const readSeller = () => {
  try {
    const raw = localStorage.getItem("seller");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const emitCartUpdated = () => {
  window.dispatchEvent(new Event("cart-updated"));
};
